import Stringer from "@/packages/stringer/src/Stringer";

function removeNullUndefinedWithReduce(obj) {
	return Object.entries(obj).reduce((acc, [key, value]) => {
		value = typeof value === "object" ? removeNullUndefinedWithReduce(value) : value;
		if (typeof value === "object" && !Object.keys(value).length) {
			value = null;
		}
		if (value !== null && value !== undefined && value !== "" && value !== {}) {
			acc[key] = value; // typeof value === "object" ? removeNullUndefinedWithReduce(value) : value;
		}
		return acc;
	}, {});
}

export function updateUrlQuery(response) {
	let url = new URL(response.request.responseURL);
	let location = new URL(window.location);
	let parsedQuery = Qs.parse(new Stringer(url.search).lTrim("\\?").value);
	location.search = Qs.stringify(parsedQuery); // removeNullUndefinedWithReduce(parsedQuery)
	history.replaceState(null, "", location);
}
